import React, { Component } from 'react'
import './style.css'

class Typings extends Component {
  render () {
    return (
      <div className='typings-main-container'>
        <div className='typings-additional-imgs'>
          <img src='https://i.imgur.com/7eKAd9N.jpg' className='typings-img-alt' alt='' />
          <img src='https://i.imgur.com/drvZ7fx.jpg' className='typings-article' alt='' />
          <img src='https://i.imgur.com/3zuzYsW.jpg' className='typings-2-img-alt' alt='' />
        </div>
      </div>
    )
  }
}

export default Typings
